<layout-page-container
  [ngClass]="{'lg:absolute lg:!left-0 lg:!inset-y-0 lg:!w-[calc(100%-36rem)]': compositionCreator}">
  <layout-header-container title="Items">
    @if (qCategory) {
      <span class="inline-flex pl-2 no-linebreak place-self-end text-lg w-full"> - {{ qCategory.name }}
        <a (click)="SetCategory()" class="place-self-center pl-2 text-red-400 hover:text-red-600 cursor-pointer">
        <svg class="bi bi-x-circle-fill" height="16" viewBox="0 0 16 16"
             width="16" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
        </svg>
      </a>
    </span>
    }

    <div class="w-full grid">
      @if (PermissionService.CheckPermission(PermissionService.CombinedPermission_CompositionCreate())) {
        <button (click)="compositionCreator = true;"
                [class.!pr-14]="create.components.length > 0"
                [class.lg:hidden]="compositionCreator"
                class="cursor-pointer inline-flex relative place-self-end rounded-full bg-theme-primary-700 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-theme-primary-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-900 h-10"
                type="button">
          <svg class="bi bi-diagram-2 place-self-center" height="16" viewBox="0 0 16 16"
               width="16" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 5 7h2.5V6A1.5 1.5 0 0 1 6 4.5v-1zM8.5 5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1zM3 11.5A1.5 1.5 0 0 1 4.5 10h1A1.5 1.5 0 0 1 7 11.5v1A1.5 1.5 0 0 1 5.5 14h-1A1.5 1.5 0 0 1 3 12.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm4.5.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 9 12.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
              fill-rule="evenodd"/>
          </svg>
          <span class="self-center pl-2 hidden md:block">Artikel {{ isEditMode ? "bearbeiten" : "anlegen" }}</span>
          @if (create.components.length > 0) {
            <div
              class="bg-white text-theme-primary-700 rounded-full absolute inset-y-0.5 right-0.5 w-9 flex">
              <span class="m-auto">{{ create.components.length }}</span>
            </div>
          }
        </button>
      }
    </div>
  </layout-header-container>
  <layout-form-container (clear)="newItemName = ''"
                         (searchValueChange)="FilterItem($event)" (submit)="AddItem()" [element]="name"
                         [permission]="PermissionService.CombinedPermission_ItemAdd()" clearText="Felder leeren"
                         submitText="Item anlegen">
    <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
      <div class="sm:col-span-4">
        <label class="block text-sm font-medium leading-6 text-gray-900" for="item-name">Name</label>
        <input #name [(ngModel)]="newItemName"
               autocomplete="item-name"
               class="mt-2 block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
               id="item-name" name="item-name"
               type="text">
      </div>
      <div class="sm:col-span-2">
        <label class="block text-sm font-medium leading-6 text-gray-900" for="item-category">Kategorie</label>
        <ng-select (ngModelChange)="setNewItemCategory($event)" [clearable]="false" [items]="categories ?? []"
                   [ngModel]="newItemCategory?.id" bindLabel="name"
                   bindValue="id"
                   class="ng-select cheqme-style mt-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
                   id="item-category"
                   name="item-category">
        </ng-select>
      </div>
    </div>
  </layout-form-container>

  <!--<div class="pt-4" *ngIf="PermissionService.CheckPermission(PermissionService.CombinedPermission_ItemAdd())">
    <label for="newItemName" class="block text-sm font-medium leading-6 text-gray-900">Neues Item</label>
    <form name="new-item" class="mt-2 grid grid-cols-1 sm:grid-cols-4 rounded-md shadow-sm">
      <div class="relative sm:col-span-2 flex-full flex flex-grow items-stretch focus-within:z-10">
        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"  class="bi bi-bookmarks"
               viewBox="0 0 16 16">
            <path
              d="M2 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v11.5a.5.5 0 0 1-.777.416L7 13.101l-4.223 2.815A.5.5 0 0 1 2 15.5V4zm2-1a1 1 0 0 0-1 1v10.566l3.723-2.482a.5.5 0 0 1 .554 0L11 14.566V4a1 1 0 0 0-1-1H4z"/>
            <path
              d="M4.268 1H12a1 1 0 0 1 1 1v11.768l.223.148A.5.5 0 0 0 14 13.5V2a2 2 0 0 0-2-2H6a2 2 0 0 0-1.732 1z"/>
          </svg>
        </div>
        <input type="text" name="newItemName" id="newItemName" [(ngModel)]="newItemName"
               class="block w-full rounded-t-md sm:rounded-none sm:rounded-l-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6"
               placeholder="Name">
      </div>
      <select *ngIf="PlatformScannerService.getPlatform() != Platform.Safari" style="text-align-last: center"
              name="newItemCategory" id="newItemCategory" [(ngModel)]="newItemCategory"
              class="mb-2 sm:!mb-0 relative -mt-px sm:mt-0 rounded-b-md sm:-ml-px inline-flex items-center gap-x-1.5 sm:rounded-none px-3 py-2 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
        <option *ngFor="let category of categories" [ngValue]="category">{{ category.name }}</option>
      </select>
      <app-combobox *ngIf="PlatformScannerService.getPlatform() == Platform.Safari" [classes]="'md:-ml-px'"
                    [nyObjects]="categories" [displayProperty]="'name'" [idProperty]="'id'"
                    (nySelection)="newItemCategory = $event" [filter]="false"></app-combobox>

      <button (click)="AddItem()" type="submit"
              class="relative sm:-ml-px inline-flex justify-center items-center gap-x-1.5 col-span-1 rounded-md sm:rounded-none sm:rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"  class="bi bi-send"
             viewBox="0 0 16 16">
          <path
            d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z"/>
        </svg>
        Hinzufügen
      </button>
    </form>
</div>-->
  <!--<input #search (input)="FilterItem(search.value)" type="text" name="search" id="search"
         class="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6 mb-4"
         placeholder="Item suchen...">-->
  <layout-page-scrollable>
    @if (!itemService.items) {
      <app-loading/>
    }

    @if (filtered_items && filtered_items.length > 0) {
      <table class="min-w-full divide-y divide-gray-300">
        <thead>
        <tr>
          <th (click)="SortBy('name')" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-2"
              scope="col">
            <div class="inline-flex">
              <div class="grid grid-cols-1 gap-1">
                <svg [class.opacity-100]="field == 'name' && !inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mb-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                </svg>
                <svg [class.opacity-100]="field == 'name' && inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mt-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                </svg>
              </div>
              <a
                class="cursor-pointer select-none place-self-center pl-2 text-sm text-theme-primary-700 hover:text-theme-primary-900">Name</a>
            </div>
          </th>
          <th (click)="SortBy('created')"
              class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 md:table-cell"
              scope="col">
            <div class="inline-flex">
              <div class="grid grid-cols-1 gap-1">
                <svg [class.opacity-100]="field == 'created' && !inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mb-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                </svg>
                <svg [class.opacity-100]="field == 'created' && inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mt-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                </svg>
              </div>
              <a
                class="cursor-pointer select-none place-self-center pl-2 text-sm text-theme-primary-700 hover:text-theme-primary-900">Erstellt
                am</a>
            </div>
          </th>
          <th class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 2xl:table-cell" scope="col">
            ID
          </th>
          <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" scope="col">Maßeinheit</th>
          <th (click)="SortBy('invnb')" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
              scope="col">
            <div class="inline-flex">
              <div class="grid grid-cols-1 gap-1">
                <svg [class.opacity-100]="field == 'invnb' && !inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mb-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                </svg>
                <svg [class.opacity-100]="field == 'invnb' && inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mt-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                </svg>
              </div>
              <a
                class="cursor-pointer select-none place-self-center pl-2 text-sm text-theme-primary-700 hover:text-theme-primary-900">Inv&nbsp;#</a>
            </div>
          </th>
          <th (click)="SortBy('category')"
              class="hidden sm:table-cell px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
              scope="col">
            <div class="inline-flex">
              <div class="grid grid-cols-1 gap-1">
                <svg [class.opacity-100]="field == 'category' && !inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mb-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                </svg>
                <svg [class.opacity-100]="field == 'category' && inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mt-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                </svg>
              </div>
              <a
                class="cursor-pointer select-none place-self-center pl-2 text-sm text-theme-primary-700 hover:text-theme-primary-900">Kategorie</a>
            </div>
          </th>
          <th class="relative py-3.5 pl-3 pr-4 sm:pr-0 text-lg" scope="col">
            <span class="sr-only">Edit</span>
          </th>
        </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          @for (item of filtered_items; track item.id) {
            <tr>
              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 inline-flex">
                @if (PermissionService.CheckPermission(PermissionService.CombinedPermission_CompositionCreate())) {
                  <a (click)="AddToCompositionRework(item)"
                     class="place-self-center cursor-pointer text-gray-500 hover:text-gray-700">
                    <svg class="bi bi-plus" height="32" viewBox="0 0 16 16" width="32"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                  </a>
                }
                <a
                  [ngClass]="{'pointer-events-none text-gray-800' : !PermissionService.CheckPermission(PermissionService.Permissions_CompositionComponent())}"
                  [queryParams]="{ item: item.id }" [routerLink]="['/compositions']"
                  class="place-self-center text-theme-primary-700 hover:text-theme-primary-900 cursor-pointer">{{ item.name }}</a>
              </td>
              <td
                class="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 md:table-cell">{{ (item.created) | date : "dd.MM.yyyy, HH:mm" }}
                Uhr
              </td>
              <td class="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 2xl:table-cell">{{ item.id }}</td>
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                @if (PermissionService.CheckPermission(PermissionService.Inventory_Item_SetUnit())) {
                  <select (ngModelChange)="ChangeUnitType(item, $event)"
                          [ngModel]="item.unit"
                          class="rounded-md border border-gray-200 bg-white py-1 pl-2 pr-6 text-sm text-gray-700 shadow-sm transition-all focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500">
                    @for (unit of units; track unit) {
                      <option [ngValue]="Number(unit[0])"
                              [selected]="Number(unit[0]) == item.unit">{{ UnitConverter.GetString(Number(unit[0])) }}
                      </option>
                    }
                  </select>
                } @else {
                  <span>{{ UnitConverter.GetString(Number(item.unit)) }}</span>
                }
              </td>
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell">
                <a
                  (click)="SetInvNumber(item)"
                  [ngClass]="{'pointer-events-none text-gray-800' : !PermissionService.CheckPermission(PermissionService.Inventory_Item_SetSourceDetail())}"
                  class="cursor-pointer text-theme-primary-700 hover:text-theme-primary-900">
                  <!--{{ item.invNumber == 0 ? "-" : item.invNumber }}-->
                  {{ item.latestSourceDetail?.inventoryId == null ? "-" : item.latestSourceDetail?.inventoryId }}
                </a>
              </td>
              <td class="hidden sm:inline-flex whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                @if (PermissionService.CheckPermission((PermissionService.Inventory_Category_Get()))) {
                  <a (click)="SetCategory(item.category.id)"
                     class="place-self-center pr-2 cursor-pointer text-theme-primary-700 hover:text-theme-primary-900">
                    <svg class="bi bi-search" height="16" viewBox="0 0 16 16" width="16"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                    </svg>
                  </a>
                }
                {{ item.category.name }}
              </td>
              <td class="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                <div class="flex items-center justify-end gap-1">
                  @if (PermissionService.CheckPermission(PermissionService.Inventory_Item_SetSourceDetail())) {
                    <a (click)="OpenSourceDetailsPopup(item)"
                       class="inline-flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 cursor-pointer select-none"
                       matTooltip="Item-Details">
                      <svg class="bi bi-info-circle" height="18" viewBox="0 0 16 16"
                           width="18" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path
                          d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                      </svg>
                    </a>
                  }
                  @if (PermissionService.CheckPermission(PermissionService.Inventory_Item_Get())) {
                    <a (click)="redirectToSettings(item.id)"
                       class="inline-flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 cursor-pointer select-none"
                       matTooltip="Bearbeiten">
                      <svg class="bi bi-pen" height="18" viewBox="0 0 16 16" width="18"
                           xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"/>
                      </svg>
                    </a>
                  }
                  @if (PermissionService.CheckPermission(PermissionService.Inventory_Item_Delete())) {
                    <a (click)="RemoveItem(item)"
                       class="inline-flex h-8 w-8 items-center justify-center rounded-lg text-red-500 transition-colors hover:bg-red-50 hover:text-red-600 cursor-pointer select-none"
                       matTooltip="Löschen">
                      <svg class="bi bi-trash3" height="18" viewBox="0 0 16 16" width="18"
                           xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                      </svg>
                    </a>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </layout-page-scrollable>
</layout-page-container>

@if (compositionCreator) {
  <div class="absolute inset-0 z-10 opacity-30 bg-gray-600 lg:hidden">
  </div>
}


<!-- sidebar -->
<div [class.hidden]="!compositionCreator" aria-labelledby="slide-over-title"
     aria-modal="true"
     class="absolute inset-y-0 right-0 w-full max-w-xl z-10 transition-all"
     role="dialog">
  <div class="absolute inset-0 overflow-hidden pointer-events-none">
    <div class="absolute inset-0 overflow-hidden">
      <div class="pointer-events-none absolute inset-y-0 right-0 flex max-w-full">
        <!--
          Slide-over panel, show/hide based on slide-over state.

          Entering: "transform transition ease-in-out duration-500 sm:duration-700"
            From: "translate-x-full"
            To: "translate-x-0"
          Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
            From: "translate-x-0"
            To: "translate-x-full"
        -->
        <form class="w-screen max-w-xl pointer-events-none h-full flex flex-col py-4 px-2 lg:px-4">
          <div
            class="flex h-full flex-col divide-y divide-gray-200 bg-white shadow pointer-events-auto rounded-lg border border-gray-300">
            <!--
              `id` + `relative` are load-bearing, not decoration (#236): this is the `[appendTo]` target for
              every <ng-select> inside the slide-over. ng-select positions a portaled panel with inline offsets
              measured against this box, which only resolve if it is the panel's containing block — hence
              `relative` — and it resolves the target with `document.querySelector`, which needs a unique id.
              It must be THIS box and nothing higher up: the panel is z-1050 and the slide-over only z-10, so a
              page- or shell-level target would paint the dropdown OVER the dialog it belongs to.
            -->
            <div class="relative h-full flex flex-col" id="composition-editor-panel">
              <button (click)="compositionCreator = false"
                      class="absolute right-3 top-4 rounded-md bg-white p-1 text-gray-400 transition-colors hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-theme-primary-900"
                      type="button">
                <span class="sr-only">Close panel</span>
                <svg aria-hidden="true" class="h-5 w-5" stroke="currentColor" stroke-width="1.5"
                     viewBox="0 0 24 24">
                  <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div class="px-3 pt-4 flex flex-col">
                <h2 class="font-bold text-xl text-gray-900 tracking-tight pr-8" id="slide-over-title">
                  Artikel {{ isEditMode ? "bearbeiten" : "anlegen" }}</h2>
                <div class="mt-2">
                  <label class="block text-sm font-medium leading-6 text-gray-900" for="newCompositionName">Name</label>
                  <div class="relative mt-1 rounded-md shadow-sm">
                    <input [(ngModel)]="create.name"
                           class="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6"
                           id="newCompositionName"
                           name="newCompositionName"
                           placeholder="Name"
                           type="text">
                  </div>
                </div>
                <div class="mt-2">
                  <label class="block text-sm font-medium leading-6 text-gray-900" for="price">Preis</label>
                  <div class="relative mt-1 rounded-md shadow-sm">
                    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                      <span class="text-gray-500 sm:text-sm">&euro;</span>
                    </div>
                    <input [(ngModel)]="create.price" aria-describedby="price-currency"
                           class="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6"
                           id="price"
                           name="price"
                           placeholder="0.00" type="number">
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                      <span class="text-gray-500 sm:text-sm" id="price-currency">EUR</span>
                    </div>
                  </div>
                </div>
                <div class="flex mt-2">
                  <components-checkbox [(isChecked)]="create.special" label="Als Special anlegen?"/>
                </div>
                <div class="inline-flex items-center py-3 w-full">
                  <a (click)="AddToCompositionRework(undefined, false)"
                     class="pr-3 cursor-pointer text-theme-primary-700 hover:text-theme-primary-900 transition-colors"
                     matTooltip="Bestandteil hinzufügen">
                    <span class="align-middle text-2xl icon-[ph--circles-three-plus]"></span>
                  </a>
                  <label class="place-self-center font-bold leading-6 text-gray-800 tracking-tight select-none">Items</label>
                  <div class="grid w-full select-none place-self-center">
                    <a (click)="create.components = []"
                       class="pr-0 text-sm text-red-600 hover:text-red-800 place-self-end cursor-pointer select-none">Alle
                      entfernen
                    </a>
                  </div>
                </div>
              </div>
              <div class="w-full px-3">
                <div class="h-0.5 bg-gray-300 rounded-full w-full"></div>
              </div>
              <div class="overflow-y-auto px-2 sm:px-3 h-full space-y-2 py-2" id="component-container">
                @for (component of create.components; track $index) {
                  @let item = GetItem(component.item);
                  <div [id]="'component_' + $index"
                       class="w-full p-2 flex flex-col rounded-xl border border-gray-300">
                    <div class="w-full inline-flex">
                      <!--
                        #728: the list order IS the slot arrangement — it is stamped onto
                        CompositionComponentLinker.Order on save and is what the register's "Bestandteile"
                        wizard renders in. Before #728 the only way to change it was to delete a slot and
                        re-add it at the end.
                      -->
                      <app-composition-slot-reorder (move)="MoveComponent(component, $event)"
                                                    [count]="create.components.length"
                                                    [index]="$index"
                                                    class="mr-1"/>
                      <a (click)="RemoveFromCompositionsRework(component)"
                         class="text-red-400 hover:text-red-600 place-self-start pr-2 cursor-pointer w-8 shrink-0 text-center">
                        <span class="align-middle text-2xl icon-[ph--x-circle]"></span>
                      </a>
                      <div class="grid grid-cols-1 w-full min-w-0 mt-0.5">
                        <div class="inline-flex">
                          <span class="text-sm font-medium text-gray-700">Bestandteil {{ $index + 1 }}</span>
                          <components-checkbox (isCheckedChange)="OptionalChanged($event, component);" [isChecked]="component.item == undefined"
                                               class="ml-auto"
                                               label="Optional?"/>
                        </div>
                        <div class="place-self-center w-full flex flex-col">
                          @if (component.item && item) {
                            <!--
                              Amount + item-select row. On phones it stacks into two lines (amount on top,
                              the item select — which needs room — on its own full-width line below); at sm+
                              they sit side by side. The item select is a plain flex sibling of the amount
                              input (no more absolute half-overlay), so it never gets squeezed.
                            -->
                            <div class="w-full min-w-0 flex flex-col gap-2 pt-2 sm:flex-row sm:items-center">
                              <!--
                                `sm:basis-56` is a PREFERRED width, not a pinned one (no `shrink-0`): the
                                amount group keeps its size on wide screens but gives room back to the item
                                select instead of overflowing when the row gets narrow (#230).
                              -->
                              <app-unit-amount-field class="min-w-0 sm:basis-56"
                                                     [item]="item"
                                                     [index]="$index"
                                                     [disabled]="!component.item"
                                                     [highlight]="component.filter"
                                                     [(value)]="component.value"
                                                     [(unit)]="component.unit"/>
                              <div class="flex items-center gap-1 min-w-0 grow">
                                <!--
                                  `for` must name the INNER input, not the `<ng-select>` host: a custom element
                                  is not labelable, so `for="item_selector_N"` left this field unlabelled (axe
                                  `label`, critical). `labelForId` is ng-select's own hook — it stamps the id
                                  onto the input it renders. Same pattern as the navbar search.
                                -->
                                <label class="sr-only" for="{{'item_selector_input_' + $index}}">Item</label>
                                <!--
                                  #236: the option list is taller than `#component-container`, whose
                                  `overflow-y-auto` used to cut it off. `appendTo` portals the panel out to the
                                  slide-over body; `NgSelectScrollAwareDirective` (auto-applied by the
                                  `ng-select[appendTo]` selector) keeps it glued to this input while
                                  `#component-container` scrolls, and closes it once the input scrolls away.
                                -->
                                <ng-select [(ngModel)]="component.item" [disabled]="!component.item"
                                           appendTo="#composition-editor-panel"
                                           class="grow min-w-0 ng-select cheqme-style block rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
                                           clearable="false"
                                           id="{{'item_selector_' + $index}}"
                                           labelForId="{{'item_selector_input_' + $index}}"
                                           name="{{'item_selector_' + $index}}">
                                  @for (item of itemService.items; track item.id) {
                                    @if (item.category.items.includes(component.item) || !component.filter) {
                                      <ng-option [value]="item.id">{{ item.name }}</ng-option>
                                    }
                                  }
                                </ng-select>
                                <a (click)="AddInterchangeableComponent(component)"
                                   class="themed-link place-self-center w-8 shrink-0 text-center" matTooltip="Optionen konfigurieren"
                                   matTooltipPosition="left">
                                  <span class="text-2xl icon-[ph--stack]"></span>
                                </a>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    @if (component.interchangeableGroup) {
                      <app-interchangeable-group-attached-widget [component]="component"/>
                    }
                  </div>
                }
              </div>
              <div class="w-full px-3">
                <div class="h-0.5 bg-gray-300 rounded-full w-full"></div>
              </div>
              <div class="relative px-3 flex flex-col">
                @if (!isEditMode) {
                  <!--
                    Always-visible, wrapping / vertically-scrollable tag pill strip (was gated behind
                    `hidden tall:flex`, which hid tags on phones). Extracted so it can be tested and
                    storied in isolation — see item-tag-picker + items-management.md.
                  -->
                  <app-item-tag-picker [selectedIds]="create.tags" [tags]="tags"
                                       (toggle)="toggleTag($event)"/>
                }

                <div class="flex flex-wrap gap-2 py-3">
                  <button (click)="upsertComposition(true)"
                          class="items-center inline-flex flex-1 sm:flex-none justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 transition-all duration-200 hover:ring-gray-400 active:scale-95"
                          type="button">
                    Speichern &amp; Schließen
                  </button>
                  <button (click)="upsertComposition(false)"
                          class="items-center inline-flex flex-1 sm:flex-none justify-center rounded-md bg-theme-primary-700 px-3 py-2 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:bg-theme-primary-900 active:scale-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-900"
                          type="submit">
                    Speichern
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

@if (visiblePopUp === PopUps.EditSourceDetails && editingItem) {
  <div aria-labelledby="modal-title"
       aria-modal="true" class="relative z-10"
       role="dialog">
    <!--
      Background backdrop, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="fixed inset-0 bg-gray-500/75 transition-opacity"></div>

    <div class="fixed inset-0 z-10 overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-0 text-center sm:items-center sm:p-4">
        <!--
          Modal panel, show/hide based on modal state.

          Entering: "ease-out duration-300"
            From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            To: "opacity-100 translate-y-0 sm:scale-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100 translate-y-0 sm:scale-100"
            To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
        <form
          class="relative transform overflow-hidden rounded-t-2xl bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all w-full max-h-[90vh] overflow-y-auto sm:my-8 sm:max-w-md sm:rounded-2xl sm:p-6">
          <div>
            <div class="mx-auto flex h-10 w-10 items-center justify-center rounded-xl bg-theme-primary-50 text-theme-primary-600">
              <svg class="bi bi-info-circle" height="24" viewBox="0 0 16 16" width="24"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path
                  d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
              </svg>
            </div>
            <div class="mt-3 text-center">
              <h3 class="text-lg font-bold leading-6 text-gray-900 tracking-tight" id="modal-title">Item-Details</h3>
              <div class="mt-2">

                <div class="pb-3 text-left text-sm text-gray-700 space-y-0.5">
                  <p><span class="font-bold text-gray-900">Name: </span>{{ editingItem.name }}</p>
                  <p><span class="font-bold text-gray-900">Kategorie: </span>{{ editingItem.category.name }}</p>
                  <p class="truncate"><span class="font-bold text-gray-900">ID: </span>{{ editingItem.id }}</p>
                </div>

                <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                  <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-6 text-gray-900 text-left" for="invId">Inventar
                      ID</label>
                    <div class="relative mt-1 rounded-md shadow-sm">
                      <input [(ngModel)]="sourceDetailInvId"
                             class="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6"
                             id="invId" name="invId" placeholder=""
                             step="1"
                             type="number">
                    </div>
                  </div>

                  <div class="">
                    <label class="block text-sm font-medium leading-6 text-gray-900 text-left" for="vpu">Volumen pro
                      Einheit</label>
                    <div class="relative mt-1 rounded-md shadow-sm">
                      <input [(ngModel)]="sourceDetailVPU" aria-describedby="price-currency"
                             class="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6"
                             id="vpu"
                             name="vpu"
                             placeholder="0.00" type="number">
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                        <span class="text-gray-500 sm:text-sm">{{ UnitConverter.GetString(editingItem.unit) }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="">
                    <label class="block text-sm font-medium leading-6 text-gray-900 text-left" for="ppu">Preis pro
                      Einheit</label>
                    <div class="relative mt-1 rounded-md shadow-sm">
                      <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <span class="text-gray-500 sm:text-sm">&euro;</span>
                      </div>
                      <input [(ngModel)]="sourceDetailPPU" aria-describedby="price-currency"
                             class="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6"
                             id="ppu"
                             name="ppu"
                             placeholder="0.00" type="number">
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                        <span class="text-gray-500 sm:text-sm">EUR</span>
                      </div>
                    </div>
                  </div>

                  @if (SupplierService?.Entities) {
                    <div class="sm:col-span-2 grid grid-cols-1">
                      <label class="block text-sm font-medium leading-6 text-gray-900 text-left pb-1" for="supplier">Lieferant</label>
                      <select [(ngModel)]="supplierId"
                              class="rounded-md border border-gray-200 bg-white py-1.5 px-2 text-sm text-gray-700 shadow-sm transition-all focus:border-theme-primary-500 focus:ring-1 focus:ring-theme-primary-500"
                              id="supplier"
                              name="supplier">
                        <option [value]="''">-- KEINER --</option>
                        @for (supplier of SupplierService!.Entities; track supplier.id) {
                          <option [value]="supplier.id">{{ supplier.name }}
                          </option>
                        }
                      </select>
                    </div>
                  }

                  <div class="pb-3">
                    <label class="block text-sm font-medium leading-6 text-gray-900 text-left" for="upb">Einheiten pro
                      Gebinde</label>
                    <div class="relative mt-1 rounded-md shadow-sm">
                      <input [(ngModel)]="sourceDetailUPB" aria-describedby="price-currency"
                             class="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6"
                             id="upb"
                             name="upb"
                             placeholder="0" type="number">
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                        <span class="text-gray-500 sm:text-sm">St.</span>
                      </div>
                    </div>
                  </div>

                  <div class="pb-3">
                    <label class="block text-sm font-medium leading-6 text-gray-900 text-left"
                           for="sk">Lieferanten-Code</label>
                    <div class="relative mt-1 rounded-md shadow-sm">
                      <input [(ngModel)]="sourceDetailSK" aria-describedby="price-currency"
                             class="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6"
                             id="sk"
                             name="sk"
                             placeholder="" type="text">
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="mt-4 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
            <button (click)="saveItemSourceDetails()"
                    class="inline-flex w-full justify-center rounded-md bg-theme-primary-700 px-3 py-2 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:bg-theme-primary-900 active:scale-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-900 sm:col-start-2"
                    type="submit">
              Speichern
            </button>
            <button (click)="closePopUps()"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 transition-all duration-200 hover:bg-gray-100 active:scale-95 sm:col-start-1 sm:mt-0"
                    type="button">
              Abbrechen
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
}
